// extracted by mini-css-extract-plugin
module.exports = {"sdsButton":"buttons_sdsButton__D7K92","secondaryButton":"SecondaryButton_secondaryButton__48OvX buttons_sdsButton__D7K92"};